import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

const SvgSupportBlank = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
            <Path
                fill={baseColors.black}
                d="M9.694 13.407c-.572 0-1.035.477-1.035 1.049 0 .558.45 1.048 1.035 1.048s1.048-.49 1.048-1.048c0-.572-.476-1.049-1.048-1.049zm.176-7.938c-1.837 0-2.682 1.09-2.682 1.824 0 .531.45.776.817.776.736 0 .436-1.048 1.825-1.048.68 0 1.225.3 1.225.926 0 .735-.762 1.157-1.211 1.539-.395.34-.913.898-.913 2.07 0 .707.19.912.75.912.666 0 .802-.3.802-.559 0-.708.014-1.116.763-1.702.368-.286 1.525-1.212 1.525-2.492s-1.157-2.246-2.9-2.246z"
            />
            <Path
                fill={baseColors.black}
                d="M10 0C4.473 0 0 4.473 0 10v9.219c0 .431.35.781.781.781H10c5.527 0 10-4.473 10-10S15.527 0 10 0zm0 18.438H1.562V10A8.433 8.433 0 0110 1.562 8.433 8.433 0 0118.438 10 8.433 8.433 0 0110 18.438z"
            />
        </Svg>
    )
}

export default SvgSupportBlank
